import React, { useEffect, useState } from 'react';
import api from 'api';
import { API } from 'common/config-api';

/**
 * 회원등급 설정 페이지
 */
const GradeSettings = () => {
  const apiUrl = `${API.BASE_URL}`;

  const [grades, setGrades] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editingData, setEditingData] = useState({});

  // 회원등급 목록 조회
  const getGrades = async () => {
    try {
      const response = await api.get(`${apiUrl}/common/code/grade`);
      setGrades(response || []);
    } catch (error) {
      console.error('회원등급 조회 실패:', error);
      alert('회원등급 조회 중 오류가 발생했습니다.');
    }
  };

  // 등급 수정
  const handleEdit = async (id) => {
    try {
      await api.put(`${apiUrl}/common/code/grade/${id}`, editingData);
      setEditingId(null);
      setEditingData({});
      getGrades();
      alert('회원등급이 수정되었습니다.');
    } catch (error) {
      console.error('회원등급 수정 실패:', error);
      alert('회원등급 수정에 실패했습니다.');
    }
  };

  useEffect(() => {
    getGrades();
  }, []);

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <h5 className="card-title">회원등급 설정</h5>

            <p className="text-muted mb-4">
              회원등급에 따른 할인율과 포인트 적립률을 설정합니다.
            </p>

            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col" width="5%">#</th>
                  <th scope="col" width="15%">등급명</th>
                  <th scope="col" width="20%">최소 구매금액</th>
                  <th scope="col" width="15%">할인율</th>
                  <th scope="col" width="15%">포인트 적립률</th>
                  <th scope="col" width="10%">색상</th>
                  <th scope="col" width="20%">관리</th>
                </tr>
              </thead>
              <tbody>
                {grades.map((grade, index) => (
                  <tr key={grade.id}>
                    <td>{index + 1}</td>
                    <td>
                      {editingId === grade.id ? (
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          value={editingData.name || ''}
                          onChange={(e) =>
                            setEditingData({ ...editingData, name: e.target.value })
                          }
                        />
                      ) : (
                        <span
                          className="badge"
                          style={{ backgroundColor: grade.color, color: '#fff' }}
                        >
                          {grade.name}
                        </span>
                      )}
                    </td>
                    <td>
                      {editingId === grade.id ? (
                        <input
                          type="number"
                          className="form-control form-control-sm"
                          value={editingData.minPurchase || 0}
                          onChange={(e) =>
                            setEditingData({
                              ...editingData,
                              minPurchase: Number(e.target.value),
                            })
                          }
                        />
                      ) : (
                        `￥${grade.minPurchase?.toLocaleString() || 0}`
                      )}
                    </td>
                    <td>
                      {editingId === grade.id ? (
                        <div className="input-group input-group-sm">
                          <input
                            type="number"
                            className="form-control"
                            value={editingData.discount || 0}
                            onChange={(e) =>
                              setEditingData({
                                ...editingData,
                                discount: Number(e.target.value),
                              })
                            }
                          />
                          <span className="input-group-text">%</span>
                        </div>
                      ) : (
                        `${grade.discount}%`
                      )}
                    </td>
                    <td>
                      {editingId === grade.id ? (
                        <div className="input-group input-group-sm">
                          <input
                            type="number"
                            className="form-control"
                            value={editingData.pointRate || 0}
                            onChange={(e) =>
                              setEditingData({
                                ...editingData,
                                pointRate: Number(e.target.value),
                              })
                            }
                          />
                          <span className="input-group-text">%</span>
                        </div>
                      ) : (
                        `${grade.pointRate}%`
                      )}
                    </td>
                    <td>
                      {editingId === grade.id ? (
                        <input
                          type="color"
                          className="form-control form-control-color form-control-sm"
                          value={editingData.color || '#000000'}
                          onChange={(e) =>
                            setEditingData({ ...editingData, color: e.target.value })
                          }
                        />
                      ) : (
                        <div
                          style={{
                            width: '24px',
                            height: '24px',
                            backgroundColor: grade.color,
                            borderRadius: '4px',
                          }}
                        />
                      )}
                    </td>
                    <td>
                      {editingId === grade.id ? (
                        <>
                          <button
                            type="button"
                            className="btn btn-success btn-sm me-1"
                            onClick={() => handleEdit(grade.id)}
                          >
                            저장
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                              setEditingId(null);
                              setEditingData({});
                            }}
                          >
                            취소
                          </button>
                        </>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-outline-primary btn-sm"
                          onClick={() => {
                            setEditingId(grade.id);
                            setEditingData({
                              name: grade.name,
                              minPurchase: grade.minPurchase,
                              discount: grade.discount,
                              pointRate: grade.pointRate,
                              color: grade.color,
                            });
                          }}
                        >
                          수정
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="alert alert-info mt-3">
              <strong>안내:</strong> 회원등급은 누적 구매금액에 따라 자동으로 승급됩니다.
              Dealer 등급은 관리자가 직접 지정합니다.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GradeSettings;
